import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import AppointmentMain from './AppointmentMain';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';
import AboutED from '../../pages/home-5/AboutArea';

const Appointment = () => {
  return (
    <>
      <HeaderFive />

      <AppointmentMain />
      < AboutED />

      <FooterThree />
    </>
  );
};

export default Appointment;
